import Loading from 'components/Loading'
import useAuth from './hooks/useAuth'
import React from 'react'

const Google: React.FC = () => {
  useAuth('google')
  return (
    <Loading />
  )
}

export default Google